import * as React from "react";
import { isMbwayDetails } from "./types.js";
import { MbwayContainer } from "../../../../../../../../containers/Adyen/Mbway/containers/modules/PaymentMethodsList/containers/Adyen/Mbway/containers/MbwayContainer.js";
const Mbway = ({ details, onChange }) => {
  const initialValue = isMbwayDetails(details) ? details.phoneNumber : "+351";
  return /* @__PURE__ */ React.createElement(MbwayContainer, { initialValue, onChange });
};
export {
  Mbway
};
//# sourceMappingURL=Mbway.js.map
